export const DEFAULT_NO_LABEL = 'No';
export const DEFAULT_YES_LABEL = 'Yes';

export const NO_VALUE = 'NO';
export const YES_VALUE = 'YES';
